import { getResourceTo } from 'react/utils/utils';

export const getAddressByStopLocation = (location) => {
  if (!location) return null;

  const addressItems = [];

  const validAddresses = [
    'addressLine1',
    'addressLine2',
    'district',
    'city',
    'state',
    'country',
    'zipCode'
  ];

  Object.keys(location).forEach((key) => {
    if (validAddresses.includes(key)) {
      addressItems.push(location[key]);
    }
  });

  return addressItems.filter((item) => item).join(', ');
};

export const getSizeAliasListByStop = (stop) => {
  const {
    size1AliasConfig,
    size2AliasConfig,
    size3AliasConfig,
    actualSize1,
    actualSize2,
    actualSize3,
    plannedSize1,
    plannedSize2,
    plannedSize3
  } = stop || {};

  const getSizeAndTitle = (actual, planned) => {
    if (actual && planned) {
      return {
        size: `${actual}/${planned}`,
        title: getResourceTo('modal.stopdetails.actualplanned')
      };
    }

    return {
      size: planned,
      title: getResourceTo('modal.stopdetails.planned')
    };
  };

  const sizeConfigs = [
    { aliasConfig: size1AliasConfig, actualSize: actualSize1, plannedSize: plannedSize1 },
    { aliasConfig: size2AliasConfig, actualSize: actualSize2, plannedSize: plannedSize2 },
    { aliasConfig: size3AliasConfig, actualSize: actualSize3, plannedSize: plannedSize3 }
  ];

  return sizeConfigs
    .filter(({ aliasConfig, plannedSize }) => aliasConfig && plannedSize)
    .map(({ aliasConfig, actualSize, plannedSize }) => ({
      ...aliasConfig,
      sizeInfo: getSizeAndTitle(actualSize, plannedSize)
    }));
};
